import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

const WhatsAppIcon = ({ className = "h-5 w-5" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

export function UserReferralSection({ showDialog, setShowDialog }) {
  const handleShare = () => {
    const msg = `Participe você também e conquiste os melhores descontos da sua cidade\n\nAcesse: www.clubdocupom.com`;
    window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, '_blank');
    setShowDialog(false);
  };

  return (
    <>
      <div className="mt-12 mb-8" data-testid="referral-banner">
        <div className="relative w-full h-40 md:h-52 rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow cursor-pointer"
          onClick={() => setShowDialog(true)}>
          <img src="https://static.prod-images.emergentagent.com/jobs/9adaf070-8900-4489-a715-0d886cce6704/images/28670ba9218948ef6f546f1db6da51551540adad8838338ebd96858842f29255.png" alt="Apresente o ClubdoCupom" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-slate-900/70 to-transparent flex items-center">
            <div className="px-6 md:px-10">
              <h2 className="text-2xl md:text-3xl font-black text-white drop-shadow-lg">Apresente o ClubdoCupom<br/>para um amigo</h2>
              <p className="text-white/80 text-sm mt-2 flex items-center gap-2">
                <WhatsAppIcon className="h-4 w-4" /> Clique para compartilhar
              </p>
            </div>
          </div>
        </div>
      </div>

      <Dialog open={showDialog} onOpenChange={setShowDialog}>
        <DialogContent className="!bg-white max-w-md">
          <DialogHeader><DialogTitle className="text-xl font-bold text-slate-900">Compartilhar ClubdoCupom</DialogTitle></DialogHeader>
          <div className="space-y-4 mt-4">
            <div className="bg-green-50 border border-green-200 rounded-md p-4">
              <p className="text-slate-700 leading-relaxed">
                Participe você também e conquiste os melhores descontos da sua cidade
              </p>
              <p className="text-sm text-green-700 font-semibold mt-2">www.clubdocupom.com</p>
            </div>
            <Button onClick={handleShare} className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3" data-testid="confirm-referral-btn">
              <WhatsAppIcon className="h-5 w-5 mr-2" /> Enviar pelo WhatsApp
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
